import React, { useCallback, useState } from 'react';

import { IconButton } from '@material-ui/core';
import { OpenInNew } from '@material-ui/icons';

import { Card, Filter } from './components';
import * as S from './styles';

export default function MonitoramentoAlertas() {
  const [params, setParams] = useState({});

  // open new window
  const handleOpennewWindow = useCallback(() => {
    window.open(
      'monitoramento_alertas_fullscreen',
      '_blank',
      'toolbar=0,location=0,menubar=0'
    );
  }, []);

  return (
    <S.Wrapper>
      <S.Header>
        <Filter onCallback={setParams} />

        <IconButton
          aria-label="Abrir nova janela"
          onClick={handleOpennewWindow}
        >
          <OpenInNew />
        </IconButton>
      </S.Header>

      <Card params={params} />
    </S.Wrapper>
  );
}
